var render = function render(){var _vm=this,_c=_vm._self._c;return (this.items.length > 1)?_c('div',{staticClass:"gender"},_vm._l((_vm.items),function(item){return _c('button',{key:item.id,attrs:{"data":item.id,"title":item.nameFr+' ['+item.id+']'},on:{"click":_vm.change}},[_vm._v(_vm._s(item.nameFr))])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }